import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import { getDashboardStats } from "./api/dashboardApi";

export default function Dashboard() {
  const [stats, setStats] = useState({
    websiteUsers: 0,
    discordMembers: 0,
    downloads: 0,
    onlinePlayers: 0,
  });

useEffect(() => {
  getDashboardStats()
    .then((res) => {
      console.log(res.data);
      setStats(res.data);
    })
    .catch((err) => {
      console.error("Dashboard API Error:", err);

      if (err.response) {
        console.log("Status:", err.response.status);
        console.log("Data:", err.response.data);
      } else if (err.request) {
        console.log("No response received:", err.request);
      } else {
        console.log("Error:", err.message);
      }
    });
}, []);

  return (
    <div>
      <h2>Website Users: {stats.websiteUsers}</h2>
      <h2>Discord Members: {stats.discordMembers}</h2>
      <h2>Downloads: {stats.downloads}</h2>
      <h2>Online Players: {stats.onlinePlayers}</h2>
    </div>
  );
}